module.exports = __webpack_public_path__ + "static/img/rank.9e92f6b1.jpg";